// to do  Tree, File, Image
require('./index.less');

var ClassSet = {
    autocomplete: require('./autocomplete'),
    // checklist: require('./checklist'),
    datepicker: require('./datepicker'),
    password: require('./password'),
    radio: require('./radio'),
    select: require('./select'),
    spinner: require('./spinner'),
    checkbox: require('./checkbox'),
    text: require('./text')
};

var Factory = {
    create: function(inputType, inputModel, $container, zContext) {
        var InputClass = ClassSet[inputType];
        if (!InputClass) {
            console.error('Invalid input type ' + inputType);
            return;
        }
        return new InputClass(inputModel, $container, zContext);
    }
};

module.exports = Factory;


/*****************
 ** WEBPACK FOOTER
 ** ./src/input-factory/index.js
 ** module id = 8
 ** module chunks = 0
 **/